module.exports = __webpack_public_path__ + "img/North_Ayrshire.2b496a19.png";